import { vservice } from '@niknevis/vue-modules'
import { Filter } from '../filter'
import { InertiaQueryParamsService } from '@/modules/shared/services/inertia-query-params.service'
import uid from 'quasar/src/utils/uid.js';
import Vue from 'vue'

@vservice()
export class FilterService {
  constructor(
    private readonly queryParamsService: InertiaQueryParamsService
  ) {
  }

  public activeFilters: Record<string, string | string[]> = Vue.observable(Object.create(null))
  private filters: Filter[] = []
  private ranges = new Map<string, string>()
  private readonly keys = new Set<string>()
  public count = 0

  add(key: string, value: string) {
    Vue.set(this.activeFilters, key, value)
    return this
  }

  addRange({ fromKey, toKey }) {
    const id = uid()
    this.ranges.set(fromKey, id)
    this.ranges.set(toKey, id)
    return this
  }

  getRange(key: string) {
    return this.ranges.get(key)
  }

  has(key: string) {
    return key in this.activeFilters
  }

  get(key: string) {
    return this.activeFilters[key]
  }

  remove(key: string) {
    return Vue.delete(this.activeFilters, key)
  }

  clear() {
    this.activeFilters = Vue.observable(Object.create(null))
  }

  submit() {
    const object = {}
    this.keys.forEach(key => {
      object[key] = this.get(key)
    })

    this
      .queryParamsService
      .batchSetParams(object)
      .onSuccess(() => {
        this.update()
      })
  }

  mount(filters: Filter[]) {
    this.filters = filters
    filters.forEach(filter => {
      if (filter.key) {
        this.keys.add(filter.key)
      } else if (filter.keys) {
        this.addRange({
          fromKey: filter.keys.from,
          toKey: filter.keys.to
        })
        this.keys.add(filter.keys.from)
        this.keys.add(filter.keys.to)
      }
    })
    this.update()
  }

  private update() {
    let count = 0
    const ranges: string[] = []
    this.keys.forEach(key => {
      const filter = this.filters.find(value => value.key === key)
      const defaultValue = filter?.defaultValue
      const value = this.queryParamsService.params[key] || defaultValue
      if (value) {
        this.add(key, value as any)
        const id = this.getRange(key)
        if (id) {
          if (!ranges.includes(id)) {
            ranges.push(id)
            count++
          }
        } else {
          count++
        }
      }
    })
    this.count = count
  }
}
